export default __webpack_public_path__ + "static/media/mazorca.0d928677.png";